angular.module('dealerware.web.data').factory('DealerwareLocationModel',function(Model, DataUtils, LocationCreationEmailAddresses){

    var baseEndpoint = '/locations';

    var dataUtils = DataUtils.getInstance();

    // Mappings for non-merchant Location properties.
    var mapResponseToLocationData = function (response) {

        var formattedResponse = { };

        // Flatten address data.
        Object.keys(
            ( response.data
              && response.data.address
            ) || { }).forEach( function (key) {
                formattedResponse[key] = response.data.address[key];
            }
        );

        // Flatten and overlay location data.
        Object.keys(
            ( response.data ) || { } ).forEach( function (key) {

                // Save off address_id, which is currently in the id field and is
                // just about to get overwritten.
                if (key === 'id') {
                    formattedResponse.address_id = response.data.id
                }
                formattedResponse[key] = response.data[key];
            }
        );

        // Apply individual field munging rules.
        //
        // Having an input field <input ... name="name" /> could have unfortunate
        // side effects. Specifically, what form.name would refer to, this field or the form's name.
        formattedResponse.primary_name = formattedResponse.name;

        formattedResponse.line1  = formattedResponse.street_number || '';
        formattedResponse.line1 += formattedResponse.line1 !== '' ?
            ' ' + formattedResponse.street_name : formattedResponse.street_name;

        formattedResponse.phone_number = dataUtils.normalizePhoneNumber (
            formattedResponse.phone_number
        );

        delete formattedResponse.street_number;
        delete formattedResponse.street_name;
        delete formattedResponse.name;

        return formattedResponse;
    };

    // Mappings for location settings properties.
    var mapResponseToSettingsData = function (response) {
        return { settings: angular.copy(response.data) };
    };

    var backupSettingsProperties = { };

    var baseCustomActionArgs = {
        ignoreAssociations              : false,
        ignoreDefaultAssociationMapper  : true,
        actionMapper                    : undefined,
        disabled                        : false,
        isArray                         : false,
        isCollection                    : false,
        cache                           : false,
        timeout                         : undefined,
        withCredentials                 : false,
        ignoreDefaultParams             : true,
        ignoreDefaultRootNode           : true,
        ignoreDefaultRootNodeResponse   : false,
        ignoreDefaultRootNodeRequest    : true,
        rootNodeRequest                 : undefined
    };

    var modelArgs =
    {
        baseEndpoint: baseEndpoint,
        rootNode: 'location',

        requestTransforms: {

            // Get rid of injections and _defaults.
            removeNonModelProperties: function (data) {
                Object.keys(data).forEach(function (key) {
                    if (typeof data[key] !== 'string' && typeof data[key] !== 'number' && key !== 'settings') {
                        delete data[key];
                    }
                });
            },

            removeLocationProperties: function (data) {

                this.removeNonModelProperties (data);

                delete data.id;
                delete data.address;
                delete data.address_id;
                delete data.primary_name;
                delete data.secondary_name;
                delete data.phone_number;
                delete data.email;
                delete data.image_url;
                delete data.line1;
                delete data.line2;
                delete data.city;
                delete data.state;
                delete data.zip;
                delete data.latitude;
                delete data.longitude;
            },

            backupAndRemoveSettingsProperties: function (data) {
                this.removeNonModelProperties (data);
                backupSettingsProperties.settings = angular.copy(data.settings);
                delete data.settings;
            },

            restoreSettingsProperties: function (data) {

                if (! data.settings) {
                    data.settings = { };
                }

                backupSettingsProperties = { };
            },

            mapSettingsPropertiesToRequest: function (data) {

                data.view_vehicle_under_contract = data.settings.view_vehicle_under_contract;
                data.customers_charged           = data.settings.customers_charged;
                data.contract_required           = data.settings.contract_required;
                data.currency_code               = data.settings.currency_code;
                data.currency_symbol             = data.settings.currency_symbol;
                data.dms_provider                = data.settings.dms_provider;
                data.dms_account_number          = data.settings.dms_account_number;
                data.metric                      = data.settings.metric;
                data.minimum_age                 = data.settings.minimum_age;
                data.program_car_utilization     = data.settings.program_car_utilization;
                data.service_complete_notification = data.settings.service_complete_notification;
                delete data.settings;
            },

            respamulateSettingsPropertiesForRequest: function (data) {

                this.removeLocationProperties (data);
                this.restoreSettingsProperties (data);
                this.mapSettingsPropertiesToRequest (data);
            },

            create: function (args, data) {

                // Cleanup Location request.  See above.
                this.backupAndRemoveSettingsProperties (data);

                data.name = data.primary_name;

                delete data.id;
                delete data.address_id;

                data.admin_email = LocationCreationEmailAddresses;
            },

            update: function (args, data) {

                this.backupAndRemoveSettingsProperties (data);

                data.name = data.primary_name;

                delete data.address;
            },

            activate: function (args, data) {
                data.active = true;
            },

            updateSettings: function (args, data) {
                this.respamulateSettingsPropertiesForRequest (data);
            }
        },

        responseTransforms: new function() {

            this.deBlankify = function (data) {
                Object.keys(data).forEach( function (key) {
                    data[key] = dataUtils.isBlank(data[key]) ? '' : data[key];
                })
            };

            this.get = function (args, data) {
                this.deBlankify (data);
                data.contract_required = data.contract_required ? '1' : '0';
            };

            this.show = function (args, data) {
                data.primary_name = data.name;
            };
        },

        customActions: {

            get: {
                method                          : 'GET',
                endpoint                        : baseEndpoint + '/:location_id',
                ignoreDefaultRootNodeResponse   : true,
                rootNodeRequest                 : undefined,
                ignoreAssociations              : true,

                responseFormatter               : undefined,

                associationMapper   : {
                    mapIt: mapResponseToLocationData
                },

                ignoreDefaultAssociationMapper  : false,

                actionMapper                    : undefined,
                disabled                        : false,
                isArray                         : false,
                isCollection                    : false,
                cache                           : false,
                timeout                         : undefined,
                withCredentials                 : false,
                ignoreDefaultParams             : true,
                ignoreDefaultRootNode           : true,
                ignoreDefaultRootNodeResponse   : true,
                ignoreDefaultRootNodeRequest    : true
            },

            create: angular.extend(angular.copy(baseCustomActionArgs), {
                method                          : 'POST',
                endpoint                        : baseEndpoint,
                associationMapper   : {
                    mapIt: mapResponseToLocationData
                }
            }),

            update: angular.extend(angular.copy(baseCustomActionArgs), {
                method                          : 'PUT',
                endpoint                        : baseEndpoint + '/:location_id',
                associationMapper   : {
                    mapIt: mapResponseToLocationData
                }
            })
        }
    };

    // These are mainly duplicates of customActions above with just a few properties changed,
    // so this is more brief than repeating all attributes that Models requires.
    angular.extend(modelArgs.customActions, {
        show        : angular.extend(angular.copy(modelArgs.customActions.get),
            {
                endpoint: baseEndpoint + '/:id'
            }
        ),
        activate    : angular.copy(modelArgs.customActions.update),
        getSettings: angular.extend(
            angular.copy(modelArgs.customActions.get),
            {
                endpoint : function () {
                    return baseEndpoint + '/:location_id/settings';
                },
                associationMapper   : {
                    mapIt: mapResponseToSettingsData
                },
                ignoreAssociations  : false
            }
        ),
        updateSettings: angular.extend(
            angular.copy(modelArgs.customActions.update),
            {
                endpoint : function () {
                    return baseEndpoint + '/:location_id/settings';
                },
                associationMapper   : {
                    mapIt: mapResponseToSettingsData
                },
                ignoreAssociations  : false
            }
        ),
        getLocation: angular.extend(
            angular.copy(modelArgs.customActions.get),
            {
                ignoreAssociations  : false
            }
        )
    });

    var model = new Model(modelArgs);

    model.mapResponseToLocationData = mapResponseToLocationData;

    return model;
})
.config(function($provide) {
    $provide.decorator('LocationModel', function($delegate,$injector) {
        return $injector.get("DealerwareLocationModel");
    });
});
